/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateTeamMemberNotificationSettingsRequest} from '@cash-web/protos/squareup/timecards/scheduling/notifications.pb'
import {UpdateTeamMemberNotificationSettingsResponse} from '@cash-web/protos/squareup/timecards/scheduling/notifications.pb'


export const updateTeamMemberNotificationSettings = (request: UpdateTeamMemberNotificationSettingsRequest, options?: CashRequestOptions) => post<UpdateTeamMemberNotificationSettingsRequest, UpdateTeamMemberNotificationSettingsResponse>("/2.0/cash/update-team-member-notification-settings", request, {...options, rejectOnError: true })